import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { useOrderAPackageContext } from '../../../OrderAPackageContext';
import './alternateProducts.scss';

const OptionsTooltipContent = () => {
  return (
    <>
      <h3>How to tell if I have a gas or electric appliance.</h3>
      <br />
      <p>
        {`The easiest way to tell is to look at the back of your appliance.
        If you see a large power cord, then you have an electric appliance.
        Alternatively, if you see a pipe or a metal hose, then it’s a gas appliance.`}
      </p>
    </>
  );
};

const calculateDiff = (currentProductPricing, alternateItemPrice) => {
  const { value, mapAboveOriginalPrice, mapDetail = {} } = currentProductPricing || {};
  const { mapPolicy } = mapDetail;

  if (mapPolicy !== null) {
    const price = currentProductPricing?.value || currentProductPricing?.original;
    const diffPrice = (price || 0) - alternateItemPrice;
    if (diffPrice <= 0) {
      return '';
    }
  } else if (mapAboveOriginalPrice !== null) {
    return '';
  }

  const diff = value - alternateItemPrice;
  if (diff === 0) {
    return '';
  }
  return diff > 0 ? `(-$${diff.toFixed(2)})` : `(+$${Math.abs(diff).toFixed(2)})`;

};

export const AlternateProducts = ({ itemId }) => {
  const { state, dispatch, actions, channel } = useOrderAPackageContext();
  const { isCustomerIdentified } = state;
  const product = state.products.get(itemId);
  const { pricing } = product;
  const alternateProducts = product?.alternateProducts?.products;

  const toggleAlternateSelection = (event) => {
    if (event.currentTarget.id !== itemId) {
      dispatch(actions.toggleAlternateSelection(event.currentTarget.id, itemId));
    }
  };

  return (
    <div className="alternate-products">
      <Col className="u__bold">
        <span className="alternate-products__title">Choose Your Option</span>
        <Tooltip
          channel={channel}
          closeButton
          content={<OptionsTooltipContent />}
          maxWidth={400}
          placement="top"
          skidding={40}
        >
          <div className="alternate-products__info">
            <Image
              src="https://assets.thdstatic.com/images/v1/info.svg"
              id="alternate-product-choose-your-option"
              alt="Information icon for choose your option tooltip."
              width={17}
              height={17}
            />
          </div>
        </Tooltip>
      </Col>
      <Col className="alternate-products__options-container">
        {
          alternateProducts.map((item, index) => {
            return (
              <div
                className="alternate-products__option"
                key={index}
                id={item.itemId}
                onClick={toggleAlternateSelection}
                role="button"
                tabIndex={index}
              >
                <span
                  className={
                    classNames(
                      'alternate-products__option__radio-button',
                      { 'option-selected': itemId === item.itemId }
                    )
                  }
                >
                  <span className="alternate-products__option__radio-button--white-dot" />
                </span>
                <span className="alternate-products__option__label">{item.label}</span>
                <span className="alternate-products__option__price">
                  {!item.hasMap && calculateDiff(pricing, item.price, isCustomerIdentified)}
                </span>
              </div>
            );
          })
        }{/* eslint-disable-line */}
      </Col>
    </div>
  );
};

AlternateProducts.propTypes = {
  itemId: string.isRequired
};

AlternateProducts.displayName = 'AlternateProducts';
